(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('DashboardManagementDeleteController',DashboardManagementDeleteController);

    DashboardManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'Dashboard'];

    function DashboardManagementDeleteController($uibModalInstance, entity, Dashboard) {
        var vm = this;
        vm.dashboard = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Dashboard.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
